import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import withWidth from "@material-ui/core/withWidth/withWidth";
import {Styles} from "../../../../config/design/styles";
import Grid from "@material-ui/core/Grid/Grid";
import {withRouter} from "react-router-dom";
import {connect} from "trim-redux";
import {Translate} from "../../../../config/Translate";
import AppCard from "../../../components/layouts/components/AppCard";
import Typography from "@material-ui/core/Typography/Typography";
import Title from "../../../components/elements/Title";
import {Link} from 'react-router-dom';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import {defaultVariabls} from "../../../../config";
import {updateRedux} from "../../../../config/Security";
import SubTitle from "../../../components/elements/SubTitle";
import Button from "@material-ui/core/Button/Button";
import Badge from "@material-ui/core/Badge";
class UserGuidLine extends React.Component{
    classes = this.props.classes;
    state={

    };
    componentDidMount(){
        updateRedux();
    }
    render(){
        let {user} = this.props;
        return (

            <AppCard>
                <Grid container spacing={2}>
                    <Grid item xs={12} style={{position:"relative"}}>
                        <Title align="left">{Translate.sellerGuidLine}</Title>
                        <Typography paragraph>{Translate.userGuidLineDescription}</Typography>
                        <div style={{position:"absolute",left:10,top:10}}>
                            <Badge color="secondary" badgeContent={user.umc}>
                                <Button
                                    color="primary"
                                    size="small"
                                    variant="contained"
                                    component={Link}
                                    to='/tickets'

                                >
                                    {Translate.tickets}
                                </Button>
                            </Badge>
                        </div>

                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <AppCard className="guidline-single" component={Link} to="/account/details">
                            <img width={50} src="../assets/images/account.png" alt="account" loading="lazy"/>
                            <SubTitle>{Translate.completeYorDetails}</SubTitle>
                            <Typography className="text-center" variant="body2" component={Link} to="/account/details">{user.confirmed === "uncompleted" ? Translate.doCompleteDetails : user.confirmed === "pending" ? Translate.inCheckingDetails : Translate.compeltedDetails}</Typography>
                            <ChevronLeftRoundedIcon className="guidline-arrow" />
                        </AppCard>

                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <AppCard className="guidline-single"  component={Link} to="/account/address">
                            <img width={50} src="../assets/images/address.png" alt="resume" loading="lazy"/>
                            <SubTitle>{Translate.addAddress}</SubTitle>
                            <Typography variant="body2" component={Link} to="/account/address">{Translate.addYourAddress}</Typography>
                            <ChevronLeftRoundedIcon className="guidline-arrow" />
                        </AppCard>
                        {
                            !user.addresses[0] ?
                                <Typography component={Link} to="/account/addres" className="mt-10 simple-error-text" varaint="body2">
                                    {Translate.youHaveNoAddress}
                                </Typography>
                                : null
                        }
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <AppCard component={"a"} href={`${defaultVariabls.website}/shop`} className={"guidline-single"}>
                            <img width={50} src="../assets/images/product.png" alt="product" loading="lazy"/>
                            <SubTitle >{Translate.viewShop}</SubTitle>
                            <Typography  variant="body2">{Translate.checkProducts}</Typography>
                            <ChevronLeftRoundedIcon className="guidline-arrow" />
                        </AppCard>

                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <AppCard component={!!user.addresses[0] ? "a" : 'div'} href={`${defaultVariabls.website}/shop`} className={!!user.addresses[0] ? "guidline-single" : "disabled-appCard guidline-single"}>
                            <img width={50} src="../assets/images/order.png" alt="content" loading="lazy"/>
                            <SubTitle>{Translate.makeSimpleOrder}</SubTitle>
                            <Typography variant="body2">{Translate.makeSimpleOrderDesc}</Typography>
                            <ChevronLeftRoundedIcon className="guidline-arrow" />
                        </AppCard>
                        {
                            !!user.addresses[0] ?
                                null:
                                <Typography component={Link} to="/account/address" className="mt-10 simple-error-text" varaint="body2">
                                    <IconButton size="small">
                                        <ErrorRoundedIcon fontSize="small" className="simple-error-icon"/>
                                    </IconButton>
                                    {Translate.firstAddAnAddress}
                                </Typography>
                        }
                    </Grid>
                </Grid>
            </AppCard>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default  withRouter(withWidth()(withStyles(Styles)(connect(mstp)(UserGuidLine))));